import { ThemeProvider } from "@emotion/react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { createTheme } from "@mui/material/styles";
import { SignButton } from "components/atoms/Button";
import FundDetailCards from "components/molecules/Card/FundDetailCards";
import FundDetailSubCards from "components/molecules/Card/FundDetailSubCards";
import WinnerLists from "components/molecules/List/WinnerLists";
import * as React from "react";
import "swiper/css";
import "swiper/css/pagination";
import useStyles from "./JackpotBody.styles";
const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
    secondary: {
      main: "#ddb930",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const JackpotBody = () => {
  const classes = useStyles();
  const tickets = require("assets/tickets-jar.png");
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box className={classes.main}>
          <img
            src={tickets}
            alt="tickets"
            style={{
              width: "361px",
              height: "160px",
              marginBottom: "28px",
              marginTop: "22px",
            }}
          />
          <Box className={classes.ticketSection}>
            <FundDetailSubCards type={"total"} ticket={12} />
            <FundDetailSubCards type={"submitted"} ticket={10} />
            <FundDetailSubCards type={"ticket"} ticket={11} />
          </Box>
          <Box style={{gap:"10px",display:"flex",flexDirection:"column",width:"100%"}}>
          <FundDetailCards ethPrice={0.03} price={1200} />
          <SignButton text={"submit 1 tickets"} color={"yellow"} size={"big"} />
          </Box>
          <Box className={classes.discribeSection}>
            <Typography className={classes.titleText}>
              How the jackpot works
            </Typography>
            <Typography className={classes.detailText}>
              The jackpot is the sum of all the tickets submitted by the
              participants. To participate, submit 10 tickets. When the next
              session arrives, you might win it all!
            </Typography>
          </Box>
          <Box className={classes.winnerTitleSection}>
            <Typography className={classes.titleText}>
              Recent Winners
            </Typography>
            <Typography className={classes.viewMoreText}>View more</Typography>
          </Box>
          <Box className={classes.winnerSection}>
            <WinnerLists
              name={"@aaronandmams"}
              date={"October 21st, 2021"}
              ethPrice={"0.03ETH"}
              price={"$200"}
            />
            <WinnerLists
              name={"@aaronandmams"}
              date={"October 21st, 2021"}
              ethPrice={"0.03ETH"}
              price={"$200"}
            />
            <WinnerLists
              name={"@aaronandmams"}
              date={"October 21st, 2021"}
              ethPrice={"0.03ETH"}
              price={"$200"}
            />
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default JackpotBody;
